import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/pagination/index.js
// module id = 156
// module chunks = 0